/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RiskTreatmentActionListing = {
    uuid: string;
    title: string;
    owner: string;
    deadline: string;
    description: string;
    risks: Array<string>;
    status?: RiskTreatmentActionListing.status;
    type?: RiskTreatmentActionListing.type;
    readonly human_id?: string;
}

export namespace RiskTreatmentActionListing {

    export enum status {
        PLANNED = 'planned',
        PROGRESS = 'progress',
        IMPLEMENTED = 'implemented',
    }

    export enum type {
        FULL = 'full',
        IMPROVEMENT = 'improvement',
    }


}
